import { Store } from "redux";
import { PAGE_ROUTES } from "~/constants/pages";
import { ReduxState } from "~/types/redux";

export type GuardResult = {
  allow: boolean;
  redirectTo?: string;
};

export type GuardContext = {
  url: string;
  store: Store<ReduxState>;
};

export type RouteGuard = (ctx: GuardContext) => GuardResult;

// Concrete guards
const requireAddressGuard: RouteGuard = ({ store }) => {
  const state = store.getState();
  const installAddress = state?.address?.install;
  const hasAddressKey = Boolean(installAddress?.addressKey);
  const hasControlAddress = Boolean(installAddress?.controlNumber && installAddress?.env);

  return hasAddressKey || hasControlAddress ? { allow: true } : { allow: false, redirectTo: PAGE_ROUTES.ADDRESS_CHECK };
};

// Registry of guarded routes. Add new rules here to extend behavior.
// Order matters: first rule that matches a path will be evaluated; multiple guards per path are AND'ed.
export const GUARDED_ROUTES: Record<string, RouteGuard[]> = {
  [PAGE_ROUTES.PLAN_PACKAGE]: [requireAddressGuard],
};

// Evaluate matching guards for a given URL
export function evaluateRoute(url: string, store: Store<ReduxState>): GuardResult {
  // Normalize to pathname (ignore query/hash)
  const pathname = url.split("?")[0].split("#")[0];
  const guards = GUARDED_ROUTES[pathname];
  if (!guards || guards.length === 0) return { allow: true };

  for (const guard of guards) {
    const res = guard({ url: pathname, store });
    if (!res.allow) return res;
  }

  return { allow: true };
}
